import React, { useCallback, useRef } from 'react';
import { useVideoPreview } from '../../hooks/useVideoPreview';
import styles from './VideoPreview.module.css';

const VideoPreview = ({ 
  companyId, 
  size = "Desktop 1440", 
  autoPlay = true, 
  controls = false, 
  loop = true 
}) => {
  const videoRef = useRef(null);
  const { data, isLoading, error } = useVideoPreview(companyId, size);

  const handleVideoError = useCallback((e) => {
    console.error("Video error event:", e);
  }, []);

  // Convertir el tamaño a formato camelCase para las clases CSS
  const sizeClass = size.toLowerCase().replace(' ', '');

  if (isLoading) {
    return (
      <div className={`${styles.container} ${styles[sizeClass]}`}>
        <div className={styles.frame}>
          <div className={styles.loading}>Loading preview...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div 
        className={`${styles.container} ${styles[sizeClass]}`}
        style={{ backgroundColor: '#3A3A39' }}
      >
        <div className={`${styles.frame} ${styles.error}`}>
          <div className={styles.errorMessage}>
            {error.message || 'Error loading video'}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`${styles.container} ${styles[sizeClass]}`}
      style={{ backgroundColor: data?.containerColor }}
    >
      <div className={styles.frame}>
        <video
          ref={videoRef}
          src={data?.videoUrl}
          className={styles.video}
          autoPlay={autoPlay}
          loop={loop}
          muted
          controls={controls}
          playsInline
          onError={handleVideoError}
        />
      </div>
    </div>
  );
};

export default VideoPreview;